import Component from '../core/Component'
import Scroll from '../services/Scroll'

export const STATES = {
    REVEALED: 'is-revealed'
}

export default class Reveal extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            container: null,
            button: null
        }

        this.isOpen = false
    }

    prepare() {
        this.button = (this.ref.button) ? this.ref.button : document.querySelector('a[href*="#' + this.element.id + '"]')

        if (!this.button) {
            return
        }

        this.button.addEventListener('click', this.handleClick)
        Scroll.on('resize', this.handleResize)

        setTimeout(() => {
            this.handleResize()
        }, 500)
    }

    destroy() {
        this.button.removeEventListener('click', this.handleClick)
        Scroll.off('resize', this.handleResize)
    }

    handleResize = () => {
        this.ref.container.style.maxHeight = this.ref.container.scrollHeight + 'px'
    }

    handleClick = event => {
        event.preventDefault()
        if (!this.element.classList.contains(STATES.REVEALED)) {
            this.open()
        } else if (this.ref.button) {
            this.close()
        }
    }

    open() {
        this.element.classList.add(STATES.REVEALED)
    }

    close() {
        this.element.classList.remove(STATES.REVEALED)
    }
}
